import React from "react";
import { IndexLink, Link } from "react-router";
import "./styles.css";

const A = ({ className = "", href, onClick, target, children }) => {
  if (href) {
    if (href === "/") {
      return (
        <IndexLink
          className={`A ${className}`}
          activeClassName="active"
          to={href}
          target={target}
        >
          {children}
        </IndexLink>
      );
    }

    if (href.indexOf("https://") === 0 || href.indexOf("mailto:") === 0) {
      return (
        <a className={`A ${className}`} target={target} href={href}>
          {children}
        </a>
      );
    }

    return (
      <Link
        className={`A ${className}`}
        activeClassName="active"
        to={href}
        target={target}
      >
        {children}
      </Link>
    );
  }

  return (
    <a className={`A ${className}`} onClick={onClick}>
      {children}
    </a>
  );
};

export default A;



/** WEBPACK FOOTER **
 ** ./src/views/components/a/index.js
 **/